import request from '@/utils/request'
/**
 *
 * 员工管理
 *
 **/
// 登录、
export const login = (data: any) =>
  request({
    'url': '/user/login',
    'method': 'post',
    data
  })
  // 退出
 export const userLogout = (params: any) =>
 request({
   'url': `/user/logout`,
   'method': 'post',
   params
 })

  //获取验证码信息
  export const getVerifyCode = () => {
    // return request.get(`/user/captcha?` + Math.random(), {
    //   responseType: 'blob',
    // })
    return request({
      url: `/user/captcha?` + Math.random(),
      method: 'get',
      responseType: 'blob'
    })
  }

export const getAdminUserList = (params: any) => {
  return request({
    url: '/user/page',
    method: 'get',
    params
  })
}

// 修改---启用禁用接口
export const enableOrDisableAdminUser = (params: any) => {
  return request({
    url: `/user/status/${params.status}`,
    method: 'post',
    params: { id:params.id }
  })
}

// 新增---添加员工
export const addAdminUser = (params: any) => {
  return request({
    url: '/user',
    method: 'post',
    data: { ...params }
  })
}

// 修改---添加员工      转入接口
export const editAdminUser = (params: any) => {
  return request({
    url: '/user',
    method: 'put',
    data: { ...params }
  })
}

// 修改页面反查详情接口
export const queryAdminUserById = (id: string | (string | null)[]) => {
  return request({
    url: `/user/${id}`,
    method: 'get'
  })
}
